export const unapproveProjectDialogViewTexts = {
  title: '承認を取り消してもよろしいですか？',
  messageTop: (projectName: string) => [`${projectName}の承認を取り消します。`],
  messageBottom: [
    '承認を取り消すと、図面の追加削除・再度カウント作業が可能になりますが、カウント結果CSV・PDFのダウンロードはできなくなります。'
  ],
  buttons: {
    cancel: '承認の取り消しをやめる',
    ok: '承認を取り消しを実行する'
  }
} as const;
